"use client";

import { getStepStripDesktopShapeClasses } from "@/components/sections/sameday-delivery/stepStripDesktopShape";

const STEPS = [
  { label: "SHOP MENU", text: "Browse legal flower, vapes, edibles and more" },
  { label: "PAY SECURELY", text: "Checkout safely online using your Credit Card" },
  { label: "TRACK DELIVERY", text: "Receive your Canada Post tracking number via SMS" },
  { label: "PICK UP", text: "Collect discreetly at your local Canada Post office" },
] as const;

export default function AlbertaWeedDeliveryStepsSection() {
  return (
    <section className="w-full max-w-none" aria-labelledby="alberta-weed-delivery-heading">
      <div className="w-full">
        <div className="grid gap-4 lg:grid-cols-[1fr_1.1fr] lg:items-start lg:gap-8">
          <h2
            id="alberta-weed-delivery-heading"
            className="text-h3-mobile sm:text-h3-desktop font-bold text-text-primary"
          >
            Alberta Weed Delivery
          </h2>
          <p className="text-body-md font-medium leading-relaxed text-text-secondary">
            In search of Alberta Weed Delivery? Nothing beats Dank. It&apos;s never been easier or more affordable to get your
            bud delivered right to your door in Alberta. We are the #1 legal mail order marijuana service in Alberta.
          </p>
        </div>
        <div className="relative mt-4 w-full overflow-x-auto scrollbar-hide">
          <div className="grid min-w-max grid-cols-4 gap-[10px] lg:min-w-0">
            {STEPS.map((step, index) => (
              <article
                key={step.label}
                className={[
                  "relative flex min-h-40 min-w-[300px] lg:min-w-0 flex-col justify-between overflow-hidden rounded-xl border border-blue-10 bg-constant-white pb-4 pl-5 pr-6 pt-3 lg:pl-4 lg:pr-5",
                  getStepStripDesktopShapeClasses(index, STEPS.length),
                ].join(" ")}
              >
                <span
                  className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 select-none text-[200px] font-black leading-none text-blue-10"
                  aria-hidden
                >
                  {index + 1}
                </span>
                <span className="relative inline-block w-max rounded-xl border border-blue-10 bg-blue-5 px-3 py-1 text-body-16-desktop font-medium text-blue-60">
                  {step.label}
                </span>
                <p className="relative text-body-20-desktop font-bold leading-snug text-blue-60">{step.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
